/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-29-10 08:00:00
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Stack, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  handleSubmit: () => void,
  discardChange: () => void,
  pristine: boolean,
  submitting: boolean,
  saving: boolean,
  emptyRedirects: boolean
};

type ComposedProps = Props & WithI18nProps;

class ActionsGroupOnCreating extends Component<ComposedProps> {
  render() {
    const {
      i18n,
      handleSubmit,
      pristine,
      submitting,
      saving,
      discardChange,
      emptyRedirects
    } = this.props;

    return (
      <Stack>
        {!pristine && (
          <Button disabled={submitting} onClick={discardChange}>
            {i18n.translate('AdminHTML.Common.Action.cancel')}
          </Button>
        )}

        <Button
          primary
          onClick={handleSubmit}
          disabled={pristine || submitting || emptyRedirects}
          loading={saving && !pristine}>
          {i18n.translate('AdminHTML.Redirects.Redirects.save')}
        </Button>
      </Stack>
    );
  }
}

export default withI18n()(ActionsGroupOnCreating);
